module.exports = __webpack_public_path__ + "img/icon-morning.03bb7f78.svg";